import {register} from '../vendor/theme-scripts/theme-sections';
import {slider} from '../features/slider';
import {RadioSwatch, GridSwatch} from '../features/swatch';
import {ProductSiblings} from '../features/siblings';
import tabs from '../features/tabs';
import {QuickAddProduct} from '../features/quick-add-product';

register('product-grid', [slider, tabs]);

if (!customElements.get('quick-add-product')) {
  customElements.define('quick-add-product', QuickAddProduct);
}

if (!customElements.get('radio-swatch')) {
  customElements.define('radio-swatch', RadioSwatch);
}

if (!customElements.get('grid-swatch')) {
  customElements.define('grid-swatch', GridSwatch);
}

if (!customElements.get('product-siblings')) {
  customElements.define('product-siblings', ProductSiblings);
}
